import PropTypes from "prop-types";
import React from "react";

function hashColor(color) {
  if (color.indexOf("#") !== 0) {
    color = "#" + color;
  }
  return color;
}

class MediaLifeEvent extends React.Component {
  render() {
    let life_event = this.props.data;

    let image = "";

    if (life_event.media.image.src) {
      image = life_event.media.image.src;
    }

    let textStyle = {
      color: hashColor(this.props.color)
    };

    let mediaBg = {
      backgroundImage: "url(" + image + ")"
    };

    let colorBg = {
      backgroundColor: hashColor(this.props.bgcolor)
    };

    let animClass = "col-md-6";

    if (this.props.preload === true) {
      animClass = "col-md-6";
    }

    return (
      <div className="row">
        <div id="message" className={animClass} style={colorBg}>
          <h1 style={textStyle}>{life_event.title}</h1>
          <h2 style={textStyle}>{life_event.description}</h2>
        </div>
        <div id="media" className="col-md-6" style={mediaBg} />
      </div>
    );
  }
}

MediaLifeEvent.propTypes = {
  color: PropTypes.string,
  bgcolor: PropTypes.string,
  preload: PropTypes.bool,
  data: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string
  })
};

export default MediaLifeEvent;
